import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet"
// import { markerImageSrc } from "./map-marker-image";
import { useLocation } from "@reach/router"

const LocRatingMap = (props) => {
      const [libkey, setLibkey] = useState('');
      const location = useLocation();
      const currentUrl = location.href 
      var Lat = props.Latitude;
      var Lng = props.Longitude;
      
      let getlibkey ="";
      useEffect(() => { 
          getlibkey = document.getElementById("location-map");
        setTimeout(() => {
          setLibkey(getlibkey?.src?.split("key=")?.pop());
        }, 1000);
      }, []);

      var iframe_url = "https://schools.locrating.com/html5/plugin/schoolsmap.aspx?&lat="+Lat+"&lng="+Lng+"&zoom=15&icon=https://ggfx-locationl.s3.eu-west-2.amazonaws.com/i.prod/marker_d0db45e777.png&id=map_schools_frame&pluginmode=plugin&hidesearchcontrol=true&hidemenu=true&fullpath="+currentUrl+"&libkey="+libkey+"";

      return (
        <>
        <div id={`map_schools`} className={"map_cnt"}></div>
        {libkey && 
        <iframe id="map_schools_frame" src={iframe_url}></iframe>
        }
        
        </>
      )
}

export default LocRatingMap;